(ns humbleai.belt.malli.transform.strip-extra-keys
  (:require
   [malli.core :as m]
   [malli.transform :as mt]))

;; NOTE strips on leave unlike the malli strip keys transformer
(def transformer
  (let [accept (m/-comp #(or (nil? %) (true? %)) :closed m/properties)
        strip-map (fn [stage]
                    {:compile (fn [schema _]
                                (let [default-schema (m/default-schema schema)
                                      ks (some->> schema (m/explicit-keys) (set))]
                                  (cond-> nil
                                    (accept schema)
                                    (assoc stage (fn [x]
                                                   (if (and (map? x) (not default-schema))
                                                     (reduce-kv (fn [acc k _] (if-not (ks k) (dissoc acc k) acc)) x x)
                                                     x))))))})
        strip-map-of (fn [stage]
                       {:compile (fn [schema options]
                                   (let [entry-schema (m/into-schema :tuple nil (m/children schema) options)
                                         valid?       (m/validator entry-schema options)]
                                     {stage (fn [x]
                                              (reduce (fn [acc entry]
                                                        (if (valid? entry)
                                                          (apply assoc acc entry)
                                                          acc)) (empty x) x))}))})]
    (mt/transformer
     {:decoders {:map (strip-map :leave), :map-of (strip-map-of :leave)}
      :encoders {:map (strip-map :enter), :map-of (strip-map-of :enter)}})))
